var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-register-nav"},[(_vm.hasProject)?_c('Button',{attrs:{"to":{
      name: 'projects'
    },"variant":"light","icon":"pageback","radius":""}},[_vm._v("\n    サイト一覧に戻る\n  ")]):_vm._e(),(!_vm.hasProject)?_c('Button',{staticClass:"logout",attrs:{"variant":"light","radius":""},on:{"click":_vm.logout}},[_vm._v("\n    ログアウト\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }